import { Component } from '@angular/core';
import { LessonCardHomePageComponent } from '../lesson-card-home-page/lesson-card-home-page.component';
import { DwComponent, DwComponentType, DwMetaDataListCardConfigData } from '@devwareapps/devware-cap';
import { AppMetaDataItemNames } from '../../../../../meta-data/app-meta-data.service';

@DwComponent<DwMetaDataListCardConfigData>({
  name: 'Up Next Hero Card',
  key: 'upNextHeroCard',
  componentType: DwComponentType.card,
  isGlobal: false,
  parentItemName: AppMetaDataItemNames.CourseLesson,
  configData: {
    contentItemDefinitions: [{
      display: 'Main',
      contentItemKey: 'main'
    }]
  }
})
@Component({
  selector: 'app-up-next-hero-card',
  templateUrl: './up-next-hero-card.component.html',
  styleUrls: ['./up-next-hero-card.component.scss']
})
export class UpNextHeroCardComponent extends LessonCardHomePageComponent {

  get courseCode(): string | null {
    const d = this.data as any;
    const raw = d?.StudentCourseCourseIdDisplay || d?.CourseIdDisplay || d?.CourseName;
    return raw ? String(raw).toUpperCase() : null;
  }

  get lessonOrderLabel(): string | null {
    const order = (this.data as any)?.LessonOrder;
    return typeof order === 'number' ? `LESSON ${order}` : null;
  }

  get moduleName(): string | null {
    const d = this.data as any;
    return d?.CourseModuleIdDisplay || d?.CourseModuleProgressCourseModuleIdDisplay || null;
  }

  get lessonProgressPercent(): number {
    const v = (this.data as any)?.CourseLessonProgressPercentComplete;
    if (typeof v !== 'number' || isNaN(v)) {
      return 0;
    }
    return Math.max(0, Math.min(100, v));
  }

}
